import { Routes } from "@angular/router";
import { WorkflowCspOneAvailabilityOrderCancelComponent } from "./workflow-csp-one-availability-order-cancel.component";

export const WorkflowCspOneAvailabilityOrderCancelRouting: Routes = [
    {
        path: 'csp/availability/:aid/order-cancel', component: WorkflowCspOneAvailabilityOrderCancelComponent
    },
]
